/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import { List, Typography } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import NotificationCard from './NotificationCard';

const Notifications = ({
  anchorEl, handleMenuClose, notifications,
}) => {
  const profilMenuId = 'notifications';
  return (
    <Menu
      anchorEl={anchorEl}
      id={profilMenuId}
      role="menu"
      aria-label="Notifications utilisateur"
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      <List
        style={{
          paddingRight: '15px',
          paddingLeft: '15px',
          backgroundColor: notifications.length > 0 ? '#77c8e3' : '',
        }}
      >
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <MenuItem
              key={notification.id || notification.created_at}
              role="menuitem"
            >
              <NotificationCard
                message={notification.message}
                createdAt={notification.created_at}
              />
            </MenuItem>
          ))
        ) : (
          <MenuItem role="menuitem" disabled>
            <Typography>Pas de notification.</Typography>
          </MenuItem>
        )}
      </List>
    </Menu>
  );
};

Notifications.defaultProps = {
  anchorEl: null,
};

Notifications.propTypes = {
  anchorEl: PropTypes.any,
  handleMenuClose: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired,
};

function mapState(state) {
  const { currentPage } = state.ui;
  return {
    currentPage,
  };
}

export default connect(mapState, {})(Notifications);
